import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftSetIndexResponse } from '@/repositories/generated';

const content: GiftSetIndexResponse[] = [
  {
    id: '1',
    name: '〇〇市商品券セットA',
    giftSetStatus: 'SCHEDULED_SALE',
    saleAmount: 12000,
    setSalesCount: 500,
    stockCount: 500,
    giftId: '1',
    giftDetailIds: ['1', '3'],
    salesStartsAt: '2023-05-23T00:00:00+09:00',
    salesEndsAt: '2023-06-23T00:00:00+09:00',
    createdAt: '2023-04-23T00:00:00+09:00',
  },
  {
    id: '2',
    name: '〇〇市商品券セットB',
    giftSetStatus: 'SALE',
    saleAmount: 10000,
    setSalesCount: 1000,
    stockCount: 500,
    giftId: '2',
    giftDetailIds: ['1', '2'],
    salesStartsAt: '2023-04-23T00:00:00+09:00',
    salesEndsAt: '2023-05-23T00:00:00+09:00',
    createdAt: '2023-04-23T00:00:00+09:00',
  },
  {
    id: '3',
    name: '〇〇市商品券セットC',
    giftSetStatus: 'OUT_STOCK',
    saleAmount: 1000,
    setSalesCount: 10000,
    stockCount: 0,
    giftId: '3',
    giftDetailIds: ['4', '5'],
    salesStartsAt: '2023-04-23T00:00:00+09:00',
    salesEndsAt: '2023-05-23T00:00:00+09:00',
    createdAt: '2023-04-23T00:00:00+09:00',
  },
  {
    id: '4',
    name: '〇〇市商品券セットD',
    giftSetStatus: 'SALE_END',
    saleAmount: 100,
    setSalesCount: 100,
    stockCount: 0,
    giftId: '4',
    giftDetailIds: ['6', '7'],
    salesStartsAt: '2023-04-23T00:00:00+09:00',
    salesEndsAt: '2023-05-23T00:00:00+09:00',
    createdAt: '2023-04-23T00:00:00+09:00',
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const giftSet = http.get(
  createMockEndpoint('/gift_set'),
  async () => {
    await delay(500);
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);

export default giftSet;
